import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import loadable from "@loadable/component";

import styles from "./MetamenuItem.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const MetamenuItem = ({ icon, link, rel, selected, target, title }) => {
	const css = styles();
	const hasHref = link && link !== "#";

	return (
		<ReactLink
			className={clsx("mco-footer__footermenu-item", css.link, {
				[css.linkSelected + " mco-footer__footermenu-item--selected"]: selected
			})}
			rel={rel}
			to={hasHref ? link : "#"}
			target={target}
		>
			{icon && (
				<ReactSVGIcon
					className={clsx("mco-footer__footermenu-icon", css.icon)}
					src={icon}
				></ReactSVGIcon>
			)}
			<span dangerouslySetInnerHTML={{ __html: title }} />
		</ReactLink>
	);
};

MetamenuItem.propTypes = {
	icon: PropTypes.string,
	link: PropTypes.string.isRequired,
	selected: PropTypes.bool,
	target: PropTypes.string,
	title: PropTypes.string.isRequired
};

export default MetamenuItem;
